import FutureFunctionality from '../../../Components/FutureFunctionality';

const ViewAds = () => {
  const test = '';

  return <FutureFunctionality pageName="View Ads" />;
};

export default ViewAds;
